module.exports = __webpack_public_path__ + "media/images/lb/157-3ea61cf447ebcf3b57c033a527b36c0e.svg";